// Варианты «за N минут до начала»: общие для закрытия регистрации и старта трансляции
export const MINUTES_BEFORE_START_OPTIONS: { value: number; label: string }[] = [
  { value: 5, label: 'За 5 минут до начала' },
  { value: 10, label: 'За 10 минут до начала' },
  { value: 15, label: 'За 15 минут до начала' },
  { value: 30, label: 'За 30 минут до начала' },
  { value: 60, label: 'За 1 час до начала' },
  { value: 2 * 60, label: 'За 2 часа до начала' },
  { value: 3 * 60, label: 'За 3 часа до начала' },
  { value: 12 * 60, label: 'За 12 часов до начала' },
  { value: 24 * 60, label: 'За 1 день до начала' },
];
